// extracted by mini-css-extract-plugin
export default {"featureContainer":"featuredStory_featureContainer__sFoDN","textDiv":"featuredStory_textDiv__aEE-K"};